import Api from 'api';

import {
  GET_SUBACCOUNTS,
  SET_SUBACCOUNTS_PAGINATION,
  SET_SUBACCOUNTS_FILTERS,
  RESET_SUBACCOUNTS,
  TOGGLE_SUBACCOUNT,
  ADD_SUBACCOUNT,
  UPDATE_SUBACCOUNT,
  GET_SUBACCOUNT_BY_ID,
  RESET_SUBACCOUNT_FORM,
  GET_SUBACCOUNT_FORM_CONFIG,
  MODIFY_EDITING_SUBACCOUNT,
  MODIFY_CUSTOM_FIELD_EDITING_SUBACCOUNT, //Groups
  ADD_CUSTOM_FIELD_EDITING_SUBACCOUNT,
  REMOVE_CUSTOM_FIELD_EDITING_SUBACCOUNT,
} from 'subaccounts/constants';

import { SET_LISTS } from 'containers/lists/constants';

export const setPagination = (payload) => ({
  type: SET_SUBACCOUNTS_PAGINATION,
  payload,
});

export const setFilters = (payload) => ({
  type: SET_SUBACCOUNTS_FILTERS,
  payload,
});

export const getSubaccounts = (companyId, subcompanyId, filters, limit, page, orderBy, order) => ({
  type: GET_SUBACCOUNTS,
  meta: { needAuth: true },
  payload: Api.subaccounts.get(companyId, subcompanyId, filters, limit, page, orderBy, order),
});

export const reset = () => ({ type: RESET_SUBACCOUNTS });

export const toggle = (subaccountId, companyId, subcompanyId) => ({
  type: TOGGLE_SUBACCOUNT,
  meta: { id: subaccountId, needAuth: true },
  payload: Api.subaccounts.toggle(subaccountId, companyId, subcompanyId),
});

export const resetForm = () => ({ type: RESET_SUBACCOUNT_FORM });

export const getSubaccountById = (subaccountId, companyId, subcompanyId) => ({
  type: GET_SUBACCOUNT_BY_ID,
  meta: { needAuth: true },
  payload: Api.subaccounts.getById(subaccountId, companyId, subcompanyId),
});

export const getFormConfig = (companyId, subcompanyId) => (dispatch) =>
  dispatch({
    type: GET_SUBACCOUNT_FORM_CONFIG,
    meta: { needAuth: true },
    payload: Api.subaccounts.formConfig(companyId, subcompanyId),
  }).then(({ value: { accounts, depreciations } }) => {
    dispatch({
      type: SET_LISTS,
      payload: {
        accounts,
        depreciations,
      },
    });
  });

export const modifySubaccount = (payload) => ({ type: MODIFY_EDITING_SUBACCOUNT, payload });

//Groups
export const modifyCustomField = (payload) => ({
  type: MODIFY_CUSTOM_FIELD_EDITING_SUBACCOUNT,
  payload,
}); // Agregado

export const addSubaccount = (companyId, subcompanyId, subaccount) => ({
  type: ADD_SUBACCOUNT,
  payload: Api.subaccounts.add(companyId, subcompanyId, subaccount),
});

export const updateSubaccount = (subaccountId, companyId, subcompanyId, subaccount) => ({
  type: UPDATE_SUBACCOUNT,
  meta: { id: subaccountId, needAuth: true },
  payload: Api.subaccounts.update(subaccountId, companyId, subcompanyId, subaccount),
});

export const addCustomField = () => ({ type: ADD_CUSTOM_FIELD_EDITING_SUBACCOUNT });

export const removeCustomField = (index) => ({
  type: REMOVE_CUSTOM_FIELD_EDITING_SUBACCOUNT,
  payload: index,
});



// WEBPACK FOOTER //
// src/modules/secured/modules/subaccounts/actions/subaccounts_actions.js